import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ComponentsModule } from '../shared/components/components.module';

import { ExampleRoutingModule } from './example-routing.module';

import { ExampleComponent } from './example.component';


@NgModule({
  declarations: [
    ExampleComponent
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    ExampleRoutingModule,
  ]
})
export class ExampleModule { }
